// app/logPush/logPush.js

(function () {
    'use strict';
    var controllerId = 'logPush';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'datacontext', 'sectionMenu', logPushFn]);

    function logPushFn($rootScope, common, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Logs';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.log = [];
        vm.notifiche = [];
        vm.getlog = getLog;
        vm.getNotifiche = getNotifiche;
        vm.logDelete = logDelete;
        vm.pushDelete = pushDelete;

        getLog();

        function getLog() {
            return datacontext.logGetAll().then(function (data) {
                return vm.log = data;
            });
        }

        function getNotifiche() {
            return datacontext.pushGetAll().then(function (data) {                
                return vm.notifiche = data;
            });
        }

        function logDelete(item) {
            return datacontext.logDelete(item.Id).then(function (data) {
                if (data != "204") return logError('Errore durante la rimozione del dato');

                logSuccess('Dato cancellato')
                getLog();
            });
        }

        function pushDelete(item) {
            return datacontext.pushDelete(item.Id).then(function (data) {
                if (data != "204") return logError('Errore durante la rimozione del dato');

                logSuccess('Dato cancellato')
                getNotifiche();
            });
        }
    }
})();